import { CardOffer } from "components/Cards/CardOfferNew";
import {
  CardOfferNewSchema,
  CfCardOfferProps,
  cfCardOfferSchema,
} from "components/Cards/CardOfferNew/CfCardOffer/schema";
import { ContentfulLivePreview } from "@contentful/live-preview";
import { LiveInspectorData } from "types/types";
import { assert } from "superstruct";
import { convertJsonAnchorToPolyAnchor } from "components/Anchor/utils";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import React from "react";

const convertCfCardOfferProps = (dataJson: CardOfferNewSchema) => {
  try {
    assert(dataJson, cfCardOfferSchema);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  const { ctaAnchor, ...otherProps } =
    "configuration" in dataJson
      ? (dataJson.configuration as CardOfferNewSchema)
      : dataJson;
  const anchorProps = convertJsonAnchorToPolyAnchor(ctaAnchor);

  return {
    ...otherProps,
    ...anchorProps,
  };
};

const CfCardOffer = (props: CfCardOfferProps) => {
  const liveProps = useContentfulLiveUpdates({
    ...props.dataJson,
    ...props.identifiers,
    sys: { id: props.identifiers.contentful_id },
  });

  const liveInspector: LiveInspectorData = {
    card: ContentfulLivePreview.getProps({
      entryId: props.identifiers.contentful_id,
      fieldId: "configuration",
    }),
  };

  return (
    <div {...liveInspector?.card}>
      <CardOffer {...convertCfCardOfferProps(liveProps)} />
    </div>
  );
};

export default CfCardOffer;
